import { render, staticRenderFns } from "./AddBrand.vue?vue&type=template&id=df23d986"
import script from "./AddBrand.vue?vue&type=script&lang=js"
export * from "./AddBrand.vue?vue&type=script&lang=js"
import style0 from "./AddBrand.vue?vue&type=style&index=0&id=df23d986&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports